import { createBrowserClient } from "@supabase/ssr";

import { envConfig } from "~/lib/env-validation";

/**
 * Supabase browser client for the frontend.
 * Uses the publishable key — safe to expose in the browser.
 * RLS policies on the database protect data access.
 */
export function createClient() {
	return createBrowserClient(envConfig.supabaseUrl, envConfig.supabasePublishableKey);
}
